const Signature = {
  PAGE: Symbol('layout-page'),
  PAGE_CONTAINER: Symbol('layout-page-container'),
  PAGE_ROW: Symbol('layout-page-row'),
};

export { Signature };
